import { atom } from "recoil";
import persistAtom from "../recoilPersister";
// import { getAuthRoleName } from '../../helpers/auth.helper';

// const userType = getAuthRoleName();
export const myPortalState = atom({
    key: 'myPortal', // unique ID (with respect to other atoms/selectors)
    effects_UNSTABLE: [persistAtom],
    default: {
      isDrawerOpen: true,
      facilityInfo: {}
    },
  });